module.exports = __webpack_public_path__ + "static/media/Artboard.3b073302.png";